import React, { useState } from 'react';
import { useQuery } from 'react-query';
import Loading from '../../Shared/Loading';
import ProjectDeleteModal from './ProjectDeleteModal';
import ProjectRow from './ProjectRow';

const ManageProjects = () => {

    const [deleteProject, setDeleteProject] = useState(null)
    const { data: allProjects, isLoading , refetch} = useQuery('manageprojects', () =>
        fetch(`https://stark-wildwood-35883.herokuapp.com/projects`)
            .then(res => res.json())
    );

    if (isLoading) {
        return <Loading />
    }



    return (
        <div className='p-5 bg-slate-200'>
            <div class="overflow-x-auto">
                <table class="table w-full">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Cover Img</th>
                            <th>Name</th>
                            <th>Role</th>
                            <th>Website Link</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            allProjects.map((project, index) =>
                                <ProjectRow
                                    key={project._id}
                                    index={index}
                                    project={project}
                                    deleteProject={deleteProject}
                                    setDeleteProject={setDeleteProject}
                                />)
                        }
                    </tbody>
                </table>
            </div>
            { deleteProject && <ProjectDeleteModal 
            
            deleteProject={deleteProject} 
            setDeleteProject={setDeleteProject}
            refetch={refetch}
            
            ></ProjectDeleteModal> }
        </div>
    );
};

export default ManageProjects;